import React, { useCallback, useState } from 'react'
import { Route, Switch } from 'react-router-dom'
import { BreadcrumbView } from '../../../../context/breadcrumb.context'
import { IconError } from '../../../../shared/icon/icon'
import { RoleSysErrors } from '../../../../role/components/role-sys'
import { NoAccess } from '../../../../role/components/no-access'
import { ErrorsPage } from './errors-page'
import { ErrorDetail } from './error-detail'
import { crumbName, groupTitle } from './errors-format'
import { SECTION } from '../../../../shared/navigation/sections'

// The list's crumb is the sidebar's entry (shared/navigation/sections.js).
const LIST_CRUMB = SECTION.errors

// One error's crumb is named after the error (its type, or a short form of
// its message when the type is generic -- groupTitle), as a record's edit
// page is named after the record, once the detail has loaded it.
const ErrorDetailCrumb = () => {
  const [name, setName] = useState('Error')
  const onLoaded = useCallback(g => setName(crumbName(groupTitle(g))), [])
  return <BreadcrumbView Icon={IconError} text={name} parent={LIST_CRUMB}><ErrorDetail onLoaded={onLoaded} /></BreadcrumbView>
}

// /admin/errors is the list; /admin/errors/:groupID one error group. The
// route itself is gated by SYS_ERRORS, so a typed URL without it shows
// NoAccess instead of a page whose every read is refused.
export const LayoutErrors = () =>
  <Route path="/admin/errors">
    <RoleSysErrors accessRead fallback={<NoAccess what="errors" />}>
      <Switch>
        <Route path="/admin/errors/:groupID">
          <ErrorDetailCrumb />
        </Route>
        <Route path="/admin/errors">
          <BreadcrumbView Icon={LIST_CRUMB.Icon} text={LIST_CRUMB.text}><ErrorsPage /></BreadcrumbView>
        </Route>
      </Switch>
    </RoleSysErrors>
  </Route>
